import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

const Terms = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 py-16 md:py-24">
        <div className="container mx-auto px-4 max-w-3xl">
          <div className="space-y-2 mb-12">
            <span className="text-xs font-mono text-muted-foreground">[LEGAL]</span>
            <h1 className="text-3xl md:text-4xl font-bold">Terms of Service</h1>
            <p className="text-muted-foreground">Last updated: February 2, 2026</p>
          </div>
          
          <div className="prose prose-neutral dark:prose-invert max-w-none space-y-8">
            <section>
              <h2 className="text-xl font-semibold mb-4">1. Acceptance of Terms</h2>
              <p className="text-muted-foreground leading-relaxed">
                By accessing or using Strata ("the Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, do not use the Service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">2. Description of Service</h2>
              <p className="text-muted-foreground leading-relaxed">
                Strata is an AI-powered database platform that provides schema detection, data organization, automation, and workflow management capabilities. The Service includes web-based tools, APIs, and integrations.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">3. User Accounts</h2>
              <ul className="list-disc list-inside text-muted-foreground space-y-1">
                <li>You must provide accurate and complete registration information</li>
                <li>You are responsible for maintaining the security of your account</li>
                <li>You must notify us immediately of any unauthorized access</li>
                <li>You may not share your account credentials with others</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">4. Acceptable Use</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                You agree not to use the Service to:
              </p>
              <ul className="list-disc list-inside text-muted-foreground space-y-1">
                <li>Violate any applicable laws or regulations</li>
                <li>Infringe on intellectual property rights of others</li>
                <li>Upload malicious code or attempt to compromise the Service</li>
                <li>Harass, abuse, or harm other users</li>
                <li>Store or process data that you don't have rights to</li>
                <li>Circumvent usage limits or security measures</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">5. Your Data</h2>
              <p className="text-muted-foreground leading-relaxed">
                You retain all rights to data you upload to Strata. You grant us a limited license to host, process, and display your data solely to provide the Service. We do not sell your data or use it for purposes other than operating the Service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">6. Payment Terms</h2>
              <ul className="list-disc list-inside text-muted-foreground space-y-1">
                <li>Paid plans are billed monthly or annually in advance</li>
                <li>Prices are subject to change with 30 days notice</li>
                <li>Refunds are provided on a case-by-case basis</li>
                <li>Failure to pay may result in suspension of your account</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">7. Service Availability</h2>
              <p className="text-muted-foreground leading-relaxed">
                We strive to maintain 99.9% uptime for Pro tier subscribers. We reserve the right to modify, suspend, or discontinue the Service at any time. We will provide reasonable notice before any significant changes.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">8. Intellectual Property</h2>
              <p className="text-muted-foreground leading-relaxed">
                The Service, including its design, features, and content, is owned by Strata and protected by intellectual property laws. You may not copy, modify, or create derivative works without our written permission.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">9. Limitation of Liability</h2>
              <p className="text-muted-foreground leading-relaxed">
                To the maximum extent permitted by law, Strata shall not be liable for any indirect, incidental, special, consequential, or punitive damages. Our total liability shall not exceed the amount paid by you in the 12 months preceding the claim.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">10. Termination</h2>
              <p className="text-muted-foreground leading-relaxed">
                Either party may terminate this agreement at any time. Upon termination, you may export your data within 30 days. We reserve the right to suspend or terminate accounts that violate these terms.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">11. Changes to Terms</h2>
              <p className="text-muted-foreground leading-relaxed">
                We may update these terms from time to time. We will notify you of material changes via email or through the Service. Continued use after changes constitutes acceptance.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">12. Governing Law</h2>
              <p className="text-muted-foreground leading-relaxed">
                These terms are governed by the laws of India. Any disputes shall be resolved in the courts of Bangalore, Karnataka.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">13. Contact</h2>
              <p className="text-muted-foreground leading-relaxed">
                For questions about these Terms of Service, contact us at legal@strata.app.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Terms;
